import React, { useEffect } from 'react';
import { Form, Button, Panel, Stack, InputGroup, Schema, useToaster, Message } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import Brand from '@/components/Brand';
import { Link } from 'react-router-dom';
import { login } from '@/services/auth.service';
import { connect } from 'react-redux';
import Copyright from '@/components/Copyright';
import MFAPage from './MFAPage';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { useTranslation } from 'react-i18next';

const { StringType } = Schema.Types;

const model = Schema.Model({
  name: StringType().isRequired('This field is required.'),
  email: StringType()
    .isEmail('Please enter a valid email address.')
    .isRequired('This field is required.')
});

const Formulaire = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.auth.loading);

  //   const formRef = React.useRef();
  const formRef = React.useRef<any>(null);
  const [visible, setVisible] = React.useState(false);
  const [emailAddress, setEmailAddress] = React.useState('');
  const [password, setPassword] = React.useState('');
  // const [isLoading, setIsLoading] = React.useState(false);
  const toaster = useToaster();
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  // const dispatch = useDispatch();

  const handleChange = () => {
    setVisible(!visible);
  };

  const handleSignIn = async () => {
    // setIsLoading(true);
    if (!emailAddress || emailAddress.length == 0 || !password || password.length == 0) {
      toaster.push(
        <Message closable showIcon type="error">
          Check your credentials
        </Message>,
        {
          placement: 'topCenter'
        }
      );
    } else {
      await dispatch(login(emailAddress, password))
        .then(response => {
          toaster.push(
            <Message closable showIcon type="success" duration={9000}>
              {t(response.message)}
            </Message>,
            {
              placement: 'topCenter'
            }
          );
          setIsLoggedIn(true);
        })
        .catch(e => {
          toaster.push(
            <Message closable showIcon type="error">
              {t(e.message)}
            </Message>,
            {
              placement: 'topCenter'
            }
          );
        });
    }
  };

  // useEffect(() => {
  //   if (!auth.loading) {
  //     if (auth.error) {
  //       toaster.push(
  //         <Message closable showIcon type="error">
  //           {auth.error}
  //         </Message>,
  //         {
  //           placement: 'topCenter'
  //         }
  //       );
  //     } else {
  //       toaster.push(
  //         <Message closable showIcon type="success">
  //           Logged in
  //         </Message>,
  //         {
  //           placement: 'topCenter'
  //         }
  //       );
  //       // navigate('/admin');
  //       window.location.pathname = '/admin';
  //     }
  //   }
  // }, [auth]);

  return (
    <>
      {isLoggedIn ? (
        <MFAPage email={emailAddress} />
      ) : (
        <Stack
          justifyContent="center"
          alignItems="center"
          direction="column"
          style={{
            height: '95vh'
          }}
        >
          <Panel
            // bordered
            // style={{ background: '#fff', width: 400 }}
            style={{ width: 400 }}
          >
            <Brand />
            {/* <img src={image} width={300} /> */}
            {/* <SplashScreen /> */}
            <center>
              <h5 style={{ color: '#0d47a1', marginBottom: 10 }}>WORKPOINT</h5>
            </center>

            <Form ref={formRef} model={model} fluid>
              <Form.Group>
                <Form.ControlLabel>Email address</Form.ControlLabel>
                <Form.Control
                  name="email"
                  type="email"
                  value={emailAddress}
                  onChange={e => {
                    setEmailAddress(e);
                  }}
                  required
                />
              </Form.Group>
              <Form.ControlLabel>
                <span>Password</span>
              </Form.ControlLabel>
              <InputGroup inside>
                <Form.Control
                  name="name"
                  type={visible ? 'text' : 'password'}
                  value={password}
                  onChange={e => {
                    setPassword(e);
                  }}
                  required
                />
                <InputGroup.Button onClick={handleChange}>
                  {visible ? <EyeIcon /> : <EyeSlashIcon />}
                </InputGroup.Button>
              </InputGroup>
              {/* </Form.Control> */}

              <div style={{ textAlign: 'right', marginTop: 20, marginBottom: 20 }}>
                <Link to="/forgot-password">{t('Forgot password')}?</Link>
              </div>

              <Form.Group>
                <center>
                  {' '}
                  <Button
                    loading={isLoading}
                    disabled={isLoading}
                    style={{ backgroundColor: '#0d47a1', color: 'white' }}
                    type="submit"
                    block
                    onClick={handleSignIn}
                  >
                    Sign in
                  </Button>
                </center>
              </Form.Group>
            </Form>
          </Panel>
        </Stack>
      )}
      <Copyright />
    </>
  );
};

export default Formulaire;
